/**
 * WordPress dependencies
 */

import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';

const Save = (props) => {
  const {
    attributes: { align },
  } = props;

  const blockProps = useBlockProps.save({
    className: 'cards-group align' + align,
  });

  return (
    <section {...blockProps}>
      <div className="cards-group__inner container">
        <div className="cards-group__container">
          <InnerBlocks.Content />
        </div>
      </div>
    </section>
  );
};

export default Save;
